import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { loadDOMComponent } from '../../../helpers';
import { store } from '../../../store/store';
import { AppContextProvider } from '../../../Services/AppContext';
import VideoWithAutoSubmit from './VideoWithAutoSubmit';

loadDOMComponent({
	selector: 'react-video-with-auto-submit',
	// @ts-ignore
	callback: ({ container, context, props }) => {
		const src = container.getAttribute('data-src');
		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<VideoWithAutoSubmit video={src} />
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
